<template>
  <div class="relative bg-white pt-16 pb-16">
    <div class="px-4 md:px-10 mx-auto w-full">
      <div class="flex flex-wrap mt-6">
        <div class="w-full px-4">
          <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
            <div class="rounded-t mb-0 px-6 py-3 border-0">
              <div class="flex flex-wrap items-center">
                <div class="relative w-full px-4 max-w-full flex-grow flex-1">
                  <h3 class="font-semibold text-base text-blueGray-700">赞助商管理</h3>
                </div>
              </div>
            </div>
            <div class="block w-full px-6 pb-6">
    <el-table v-loading="loading" :data="tableData" border>
      <el-table-column prop="name" label="赞助商名称" width="140"></el-table-column>
      <el-table-column label="描述">
        <template #default="scope">
          <div>{{ JSON.stringify(scope.row.desc) }}</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="margin-top: 16px; text-align: right" background
      layout="total, sizes, prev, pager, next, jumper" :total="total" :page-sizes="[20, 50, 100]"
      @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
      :page-size="pageSize">
    </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      loading: false,
    };
  },
  mounted() {
    this.queryData();
  },
  methods: {
    queryData() {
      this.loading = true;
      this.$$getSponsorList(
        {
          page: this.currentPage,
          page_size: this.pageSize
        },
        (res) => {
          console.info(res)
          if (res.sta === 0) {
            this.loading = false;
            this.tableData = res.data.list;
            this.total = res.data.count;
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        },
        () => {
          this.loading = false;
          this.$message.error('请求数据失败!');
        },
      );
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryData();
    },
    handleSortChange(obj) {
      this.queryData({
        sort_key: obj.prop,
        sort_type: obj.order === "ascending" ? 1 : -1,
      });
    },
  },
};
</script>

<style></style>
